<div class="filter-dropdown-wrapper" #dropdownList>
  <input
    #searchInput
    type="text"
    class="filter-input"
    (keyup)="onKeyUp($event)"
    [attr.placeholder]="placeholder()"
  />
  <button class="chevron-down" (click)="toggleDropdown()">
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.577391 0.744078C0.902828 0.418641 1.43047 0.418641 1.7559 0.744078L6.99998 5.98816L12.2441 0.744078C12.5695 0.418641 13.0971 0.418641 13.4226 0.744078C13.748 1.06951 13.748 1.59715 13.4226 1.92259L7.58923 7.75592C7.2638 8.08136 6.73616 8.08136 6.41072 7.75592L0.577391 1.92259C0.251954 1.59715 0.251954 1.06951 0.577391 0.744078Z"
        fill="#4D5154"
      />
    </svg>
  </button>
  @if (openDropdown()){
  <ul class="filter-dropdown">
    @for (item of filteredList(); track item.id) {
    <li class="filter-dropdown-list-item" (click)="onSelectItem(item)">
      {{ item.name }}
    </li>
    }
  </ul>
  }
</div>
